import React, { useState, useEffect } from "react";
import { FieldProps } from "formik";
import { filter, get } from "lodash";
import Autosuggest from "react-autosuggest";

interface AutoCompleteSuggestion {
	id: string;
	name: string;
}

export interface AutoCompleteProps<T = any> {
	name: string;
	field: FieldProps["field"];
	form: FieldProps["form"];
	placeholder?: string;
	suggestions: AutoCompleteSuggestion[];
	toLowerCase?: boolean;
}

const AutoCompleteInput: React.FC<AutoCompleteProps> = (props) => {
	const { suggestions, field, form, placeholder, toLowerCase } = props;
	const [suggestionValue, setSuggestionValue] = useState("");

	useEffect(() => {
		if (field?.value) {
			const newValue = toLowerCase ? field.value.toLowerCase() : field.value;
			setSuggestionValue(newValue);
		}
	}, [field.value]);

	const setField = (value: string) => {
		const newValue = toLowerCase && value ? value.toLowerCase() : value;
		form.setFieldValue(field.name, newValue);
		setSuggestionValue(newValue);
	};

	const getSuggestionValue = (suggestion: AutoCompleteSuggestion) => suggestion.id;

	const onSuggestionSelected = (event: any, { suggestion }: { suggestion: AutoCompleteSuggestion }) => {
		setField(suggestion.name);
	};

	const renderSuggestion = (suggestion: AutoCompleteSuggestion) => <div>{suggestion.name}</div>;

	const onTextChange = (event: any) => {
		const value = event.target.value;

		setField(value);
	};

	const newSuggestions = filter(suggestions, (suggestion: AutoCompleteSuggestion) => {
		return suggestion.name.toLowerCase().includes(suggestionValue.toLowerCase());
	});

	const errorValue = get(form.errors, field.name);
	const touchedValue = get(form.touched, field.name);

	const hasError = errorValue && touchedValue;

	return (
		<Autosuggest
			suggestions={newSuggestions}
			onSuggestionsFetchRequested={() => null}
			onSuggestionsClearRequested={() => null}
			getSuggestionValue={getSuggestionValue}
			onSuggestionSelected={onSuggestionSelected}
			renderSuggestion={renderSuggestion}
			inputProps={{
				className: `${hasError ? "error-input" : ""}`,
				onChange: onTextChange,
				value: suggestionValue,
				id: field.name,
				placeholder: placeholder || "",
			}}
		/>
	);
};

export default AutoCompleteInput;
